module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("imXIE"))).then(() => module.bundle.root('dJXJK'));